import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import vdo2 from "../../assets/video/primesp.mp4";
import quick from "../../assets/icons/The Patient Experience.png";
import radiologist from "../../assets/icons/Safety-01.png";
import Legacy from "../../assets/icons/Integrity-01.png";
import International from "../../assets/icons/Innovation.png";
import abr from "../../assets/icons/Compassion.png";
import technologies from "../../assets/icons/Accessibility-01.png";
import poster from "../../assets/images/header/poster.jpg";
import { FaPlay, FaPause } from "react-icons/fa";
import HomeSwiper from "./HomeSwiper";
import imgs_1 from "../../assets/images/other-pages/siemens_1.jpg";
import imgs_2 from "../../assets/images/other-pages/siemens_2.jpg";
import imgs_3 from "../../assets/images/other-pages/siemens_3.jpg";
import imgs_4 from "../../assets/images/other-pages/siemens_4.jpg";
// import imgs_5 from "../../assets/images/other-pages/siemens_5.jpg";
import imgs_6 from "../../assets/images/other-pages/siemens_6.jpg";
import imgs_7 from "../../assets/images/other-pages/siemens_7.jpg";
import imgs_8 from "../../assets/images/other-pages/siemens_8.jpg";
import imgs_9 from "../../assets/images/other-pages/siemens_9.jpg";
gsap.registerPlugin(ScrollTrigger);
const HomePageDetails = () => {
  const imgContainerRef = useRef(null);
  const hospitalImgRef = useRef(null);
  useEffect(() => {
    const topImage = imgContainerRef.current;
    const hospitalImage = hospitalImgRef.current;
    gsap.to(topImage, {
      width: "100%",
      ease: "none",
      scrollTrigger: {
        trigger: topImage,
        start: "top 50%",
        end: "+=300",
        scrub: true,
      },
    });

    gsap.to(hospitalImage, {
      width: "100%",
      ease: "none",
      scrollTrigger: {
        trigger: hospitalImage,
        start: "top 50%",
        end: "+=300",
        scrub: true,
      },
    });

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);
  const videoRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const [isPaused, setIsPaused] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const video = videoRef.current;
    const checkStatus = () => setIsPaused(video.paused);

    video.addEventListener("loadeddata", checkStatus);
    return () => video.removeEventListener("loadeddata", checkStatus);
  }, []);

  const togglePlay = () => {
    const video = videoRef.current;
    if (video.paused) {
      video.play();
      setIsPaused(false);
    } else {
      video.pause();
      setIsPaused(true);
    }
  };

  const handleTimeUpdate = () => {
    const video = videoRef.current;
    const current = (video.currentTime / video.duration) * 100;
    setProgress(current || 0);
  };

  const handleSeek = (e) => {
    const video = videoRef.current;
    const newTime = (e.target.value / 100) * video.duration;
    video.currentTime = newTime;
  };
    const sildeimgs = [
    { id: 2, src: imgs_3, alt: "Siemens Slide-1" },
    { id: 3, src: imgs_4, alt: "Siemens Slide-2" },
    { id: 4, src: imgs_6, alt: "Siemens Slide-3" },
    { id: 5, src: imgs_2, alt: "Siemens Slide-4" },
    { id: 6, src: imgs_1, alt: "Siemens Slide-5" },
    { id: 7, src: imgs_8, alt: "Siemens Slide-6" },
    { id: 8, src: imgs_7, alt: "Siemens Slide-7" },
    { id: 9, src: imgs_9, alt: "Siemens Slide-8" },
  ];
  return (
    <div className="w-full h-auto">
      {/* Top Image Section with animation */}
      {/* <div
        ref={imgContainerRef}
        style={{ width: "60%" }}
        className="overflow-hidden mx-auto rounded-3xl mt-36"
      >
        <img src={top_img} alt="" className="object-contain w-full " />
      </div> */}

      {/* Why Choose CDC ? */}

      <div className=" text-center flex justify-center items-center flex-col xl:gap-10 2xl:gap-2 gap-2  xl:py-[12rem] py-[6rem] xl:px-16 2xl:px-0 text-white">
        <div className="2xl:text-6xl xl:text-[2.75rem] text-4xl   text-center font-bold mb-6 text-[#d78558] font-robout">
          <h3 data-aos="fade-up">Why Choose Citrus Diagnostic Center?</h3>
          <p className="md:text-4xl text-2xl mt-8 font-light px-5 text-white capitalize">
            Because expert care should always feel close to home.
          </p>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="100"
          className=" 2xl:w-3/4 w-[90%]  text-3xl md:text-4xl lg:text-[2rem] leading-tight lg:ps-0 md:px-8 px-4  md:text-left text-center  font-robout"
        >
          <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-0 gap-8 xl:my-20 lg:my-14 md:my-10 my-6">
            <div className="flex flex-col gap-8 xl:gap-10 xl:pe-10">
              <div className="lg:pe-10 flex flex-col gap-4">
                <h4 className="text-[#d78558] font-bold">
                  Innovation & Excellence
                </h4>
                <p className="text-xl">
                  We continually adopt the latest technology and practices to
                  provide the best possible diagnostic experience.
                </p>
              </div>
              <div className="lg:pe-10 flex flex-col gap-4">
                <h4 className="text-[#d78558] font-bold">
                  Community Commitment
                </h4>
                <p className="text-xl">
                  As lifelong Citrus County residents, we are deeply invested in
                  serving our neighbors with accessible, patient-centered
                  imaging.
                </p>
              </div>
              <div className="lg:pe-10 flex flex-col gap-4">
                <h4 className="text-[#d78558] font-bold">Trusted Legacy</h4>
                <p className="text-xl">
                  We’ve built over 3 decades of trust through integrity,
                  compassion, and excellence.
                </p>
              </div>
            </div>
            <div className="flex flex-col gap-12 ">
              <div className="xl:ps-10 flex flex-col gap-4">
                <h4 className="text-[#d78558] font-bold">Physician-Led Care</h4>
                <p className="text-xl">
                  Unlike most centers, we are physician owned and operated,
                  family owned, and locally owned. Every decision is guided by
                  radiologists trained in medical imaging—not outside business
                  interests or corporate investors.
                </p>
              </div>
              <div className="xl:ps-10 flex flex-col gap-4">
                <h4 className="text-[#d78558] font-bold">Advanced Training</h4>
                <p className="text-xl">
                  Our team consists of board-certified, subspecialty-trained
                  radiologists with expertise spanning all major areas of
                  radiology, including PET, MRI, cardiac imaging, neurological
                  imaging, vascular imaging, and women’s imaging. This ensures
                  the highest level of diagnostic accuracy and quality of care.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Hospital Image Section with animation */}
      <div className="flex justify-center items-center">
        {/* <div
          ref={hospitalImgRef}
          style={{ width: "60%" }}
          className="overflow-hidden mx-auto rounded-3xl"
        >
          <img src={Hospital} alt="" className="w-full h-full rounded-3xl" />
        </div> */}
        <HomeSwiper  sildeimgs={sildeimgs} />
      </div>
      {/* Third Content Section */}

      <div className="2xl:w-4/5 w-[90%] xl:py-[12rem] py-[6rem] xl:px-16 2xl:px-0 text-[#d78558] mx-auto ">
        {/* Header */}
        <div className="mb-8 sm:mb-10 md:mb-20 text-center max-w-[95rem] mx-auto ">
          <p
            data-aos="fade-up"
            className="font-robout  uppercase  text-[#d78558] font-bold  text-[2.5rem] leading-normal md:leading-[5rem] md:text-[4.8rem]"
          >
            Our Core Values
          </p>
          <p className="md:text-4xl text-2xl mt-8 font-medium px-5 text-white capitalize">
            Community-based radiology, academic-level expertise
          </p>
        </div>
        {/* List Items */}
        <ul className="space-y-6 sm:space-y-8 md:space-y-10 max-w-7xl mx-auto font-robout">
          {[
            {
              title: "Integrity",
              color: "text-[#d78558]",
              description:
                "We hold ourselves to the highest ethical standards. Our patients and partners can count on honesty, transparency, and doing what’s right in every situation.",
              icon: Legacy,
            },
            {
              title: "Safety",
              color: "text-[#d78558]",
              description:
                "Patient safety is at the heart of everything we do. From rigorous protocols to advanced technology, we provide a secure environment and the most accurate results possible.",
              icon: radiologist,
            },
            {
              title: "Innovation & Excellence",
              color: "text-[#d78558]",
              description:
                "We are dedicated to clinical excellence, continually advancing our knowledge and investing in leading-edge technology. This commitment ensures the highest quality imaging and care for every patient.",
              icon: International,
            },
            {
              title: "Compassion",
              color: "text-[#d78558]",
              description:
                "We see the person behind every image. Our team strives to ease anxiety, treat each patient with dignity, and provide support at every step of the process.",
              icon: abr,
            },
            {
              title: "Accessibility",
              color: "text-[#d78558]",
              description:
                "We believe world-class care should be within reach. We prioritize timely appointments, clear communication, and a welcoming environment that makes imaging more convenient and approachable.",
              icon: technologies,
            },
            {
              title: "The Patient Experience",
              color: "text-[#d78558]",
              description:
                "All of our values come together with one goal: delivering the ultimate patient experience — safe, seamless, and compassionate care that patients and providers can trust.",
              icon: quick,
            },
          ].map((item, index) => (
            <li
              key={index}
              className="flex flex-col lg:flex-row md:items-start md:justify-between border-b gap-4 border-white border-opacity-15 py-6 md:py-8"
            >
              <span
                data-aos="fade-right"
                data-aos-delay={`${index + 1 * 100}`}
                className={`font-robout lg:w-2/5 w-full md:block hidden  font-semibold ${item.color} text-3xl md:text-4xl lg:text-[2.5rem] leading-tight  mb-4 md:mb-0 `}
              >
                {item.title}
              </span>
              <div
                data-aos="fade-left"
                data-aos-delay={`${index + 1 * 100}`}
                className="flex sm:flex-row flex-col  w-full  items-center md:items-start justify-center lg:justify-end gap-4 md:gap-8"
              >
                <img src={item.icon} alt={item.title} className="w-auto" />
                <span
                  className={`font-robout text-center md:hidden block font-semibold ${item.color} text-3xl `}
                >
                  {item.title}
                </span>
                <span className="font-robout lg:w-3/5 w-full text-center md:text-left text-white text-[1.1rem]  md:text-xl lg:text-[1.3rem] leading-relaxed md:max-w-[31.35rem]">
                  {item.description}
                </span>
              </div>
            </li>
          ))}
        </ul>
      </div>
      {/* Video Section 2 */}
      <div className="flex justify-center items-center mb-20">
        <div className="xl:w-3/5 w-[90%]">
          <div
            className="relative w-full pb-[56.25%] overflow-hidden rounded-3xl shadow-lg group"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={() => setIsHovered(true)} // Show controls on tap for mobile
          >
            <video
              ref={videoRef}
              className="absolute top-0 left-0 w-full h-full object-cover"
              muted={false}
              playsInline
              poster={poster}
              onClick={togglePlay}
              onPlay={() => setIsPaused(false)}
              onPause={() => setIsPaused(true)}
              onTimeUpdate={handleTimeUpdate}
            >
              <source src={vdo2} type="video/mp4" />
              Your browser does not support the video tag.
            </video>

            {/* Custom Controls */}
            {(isHovered || window.innerWidth < 768) && (
              <>
                <input
                  type="range"
                  value={progress}
                  onChange={handleSeek}
                  onClick={(e) => e.stopPropagation()}
                  className="absolute bottom-20 sm:bottom-24 md:bottom-28 lg:bottom-[130px] left-0 w-full appearance-none h-1 sm:h-1.5 bg-gray-300 accent-blue-500 cursor-pointer z-10"
                />
                <div className="absolute bottom-4 sm:bottom-5 md:bottom-6 left-1/2 transform -translate-x-1/2 z-10">
                  <button
                    aria-label="Media Controls"
                    onClick={(e) => {
                      e.stopPropagation();
                      togglePlay();
                    }}
                    className="bg-[#d78558] text-white p-3 sm:p-4 md:p-5 rounded-full transition"
                  >
                    {isPaused ? (
                      <FaPlay className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" />
                    ) : (
                      <FaPause className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" />
                    )}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePageDetails;
